import { getMessageFactory } from "../getCaxaWebSocket.js";
const getCurrentPriceCupboardInfo = getMessageFactory({
  code: "GET_CURRENT_PRICE_CUPBOARD_INFO"
});
export { getCurrentPriceCupboardInfo };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/getCurrentPriceCupboardInfo.js